
import { defineComponent } from "vue";
import AppNav from "../app-nav/index.vue";
import AppSlide from "./app-slide.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/apps/bty-seo-pc/stores/app";

export default defineComponent({
  props: {
    btyUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      james: null as HTMLImageElement | null,
      bgLoaded: false,
    };
  },
  mounted() {
    this.james = this.$refs.james as any;
    this.bgLoaded = true;
  },
  components: {
    AppNav,
    AppSlide,
  },
  computed: {
    jamesStyle() {
      const delta = 0.2;
      const y = Math.min(this.scrollTop * delta, 50);
      return {
        transform: `translateY(${y}px)`,
      };
    },
    bgWidth() {
      const el = this.james;
      if (!el) {
        return 0;
      }
      const rect = el.getBoundingClientRect();
      const delta = 1.1;
      const right = (this.windowWidth - rect.right) * delta;
      const imageWidth = 680;
      return Math.round(right + imageWidth);
    },
    bgStyle() {
      return {
        width: this.bgWidth + "px",
      };
    },
    ...mapState(useAppStore, ["windowWidth", "scrollTop"]),
  },
  render() {
    return (
      <AppSlide class="slide1">
        <img
          style={this.bgStyle}
          class={{
            "slide1__bg-red": true,
            "slide1__bg-red--loaded": this.bgLoaded,
          }}
          src={require("./bg-red.png")}
          alt=""
        />
        <AppNav
          class={{ "slide1__app-nav": true, loaded: this.bgLoaded }}
          btyUrl={this.btyUrl}
        />
        <div class="slide1__box container">
          <div class="slide1__text-content">
            <img
              class="slide1__logo"
              src={require("./slide-logo.png")}
              alt="B SPORTS"
            />
            <h2 class={{ loaded: this.bgLoaded }}>众多游戏平台</h2>
            <h3 class={{ loaded: this.bgLoaded }}>顶尖体育平台 精彩无处不在</h3>
            <p class="desc">
              Numerous game platforms and top sports betting platforms allow you
              to place bets on exciting events anywhere.
            </p>
            <div class="slide1__btns">
              <a class="btn btn-primary" href={this.btyUrl} target="_blank">
                立即体验
                <img src={require("./arrow-right.svg")} alt="" />
              </a>
            </div>
          </div>
          <img
            style={this.jamesStyle}
            ref="james"
            class="slide1__image-james"
            src={require("./james.png")}
            alt="james"
          />
        </div>
      </AppSlide>
    );
  },
});
